import { client, gql } from './Client';

interface InspectionComment {
  inspectionId: number;
  assignmentComment: string;
}

const saveInspectionCommentMutation = gql`
  mutation addorUpdateAssignmentComment(
    $InspectionAssignmentCommentInput: InspectionAssignmentCommentInput
  ) {
    addorUpdateAssignmentComment(assignmentComment: $InspectionAssignmentCommentInput)
  }
`;

const saveInspectionComment = (InspectionAssignmentCommentInput: InspectionComment) =>
  client.mutate({
    mutation: saveInspectionCommentMutation,
    variables: { InspectionAssignmentCommentInput },
  });

export { saveInspectionComment };
